<template>
    <div class="post-editor">

        <!--<mention-suggestions v-if="suggestions" :suggestions="suggestions" @pickSuggestion="pickSuggestion"/>-->
        
        <!-- v-if="!useCkEditor" -->
        <Editor ref="sceditorcontainer" :bindKey="true" @editorKeyDown="editorKeyDown" @nodeChanged="nodeChanged" v-if="!useCkEditor"></Editor>

        <HtmlEditor v-model="editorContent" v-if="useCkEditor" />

        <div class="editor-actions">

            <div v-if="allowAttachments && !useCkEditor" class="attachments">
                <button @click="addFile">Add files</button>
                <input type="file" ref="file" @change="handleFileChange" multiple accept="image/png, image/jpeg"/>
            </div>
            
            <div v-if="allowEditReason" class="edit-controls">
                <span>Reason for edit: </span>
                <input type="text" class="reason-value" v-model="editReason">
                <input type="checkbox" v-model="trackEditReason"/>
                <span class="edit-by-checkbox-label">Show in post?</span>
            </div>

            <div class="control-buttons">
                <button class="cancel" v-on:click="cancelContent">Cancel</button>
                <button ref="submitbutton" v-on:click="submitContent" :disabled="!submitEnabled" >Submit</button>
            </div>

        </div>        
    </div>
</template>


<script>

    import Editor from '../../components/Posts/Editor.vue'
    import HtmlEditor from '../../components/Widgets/HtmlEditor';
    //import permHelper from '../PermissionHelper'
    import api from "../../api/api";
    import dialogs from '../../modules/dialogs'
    import MentionSuggestions  from "./MentionSuggestions.vue";
    import settings from "../../modules/settings";
    import htmlSanitizer from "../../modules/contentHandlers/htmlSanitizer";

    export default {
        components: {
            Editor,
            MentionSuggestions,
            HtmlEditor,
        },
        data() {
            return {
                editReason: null,
                trackEditReason: false,
                mentionState: '',
                mentionStarted: false,
                suggestions: [],
                suggestionsFeatureActive: false,
                submitEnabled: true,
                editorContent: ""
            };
        },

        props: ['content', 'cancel', 'submit', 'allowAttachments', 'allowEditReason', 'allowMentions'],

        computed: {
            useCkEditor: function() {
                return settings.user.getUseCKEditor();
            },
        },

        methods: {
            
            async handleFileChange() {

                let files = this.$refs.file.files;

                if (files) {
                    let replacements = [];
                    let inserts = [];
                    for (let i = 0; i < files.length; i++) {
                        let file = files[i];
                        try {
                            let response = await api.postFile('/attachments/attach', file) 
                            {
                                var att = response.data;
                                var elementString = '';
                                if (att.livePreview === true) {
                                    elementString = `<a target="_blank" data-ua-attachment="${att.attachmentID}" href="${att.url}"><img data-ua-attachment-preview="true" src="${att.tempUrl}" /></a>`;
                                } else {
                                    elementString = `<a target="_blank" data-ua-attachment="${att.attachmentID}" href="attachments/${att.attachmentID}" data-ua-download="true">${att.fileName}</a>`;                                
                                }
                                inserts.push('file123placeholder' + i)
                                replacements.push(elementString);
                            }
                        }
                        catch {
                            dialogs.alertAsync('Error uploading file');
                        }
                    }
                    if (replacements && replacements.length > 0) {
                        // eslint-disable-next-line
                        var instance = this.getEditorInstance();
                        instance.insert(inserts.join(''));
                        for(let i = 0; i < replacements.length; i++) {
                            let content = instance.getBody().innerHTML;
                            let elementString = replacements[i];
                            let replaced = content.replace('file123placeholder' + i, elementString);
                            instance.val(replaced, false);
                        }
                    }
                }


            },

            getEditorInstance() {
                return this.$refs.sceditorcontainer.getSCEditInstance();
            },

            addFile() {
                this.$refs.file.click();
            },

            cancelContent: async function() {
                if (await dialogs.confirmCancelAsync("Are you sure you want to cancel?") === true) {
                    this.cancel();
                }                
            },

            submitContent() {
                var self = this;
                this.submitEnabled = false;
                this.submit(
                    this.getValue(),
                    this.trackEditReason,
                    this.editReason,
                    () => { 
                        // HACK!
                        window.setTimeout(function () {
                            // force outer anchor href of live preview images to image src
                            let images = document.querySelectorAll(`img[data-ua-attachment-preview="true"]`);
                            images.forEach((img) => {      
                                img.addEventListener('click', self.clickImage);      
                            // the outer element of a preview link has the non-temp version
                                var outerAnchor = img.parentElement;
                                outerAnchor.href = img.src;
                            });
                        }, 2000);
       
                        this.submitEnabled = true; 
                    }
                );
            },

            clickImage(el) {
                event.preventDefault();
                window.open(el.srcElement.currentSrc, '_blank');
                },

            pickSuggestion(suggestion) {
                this.suggestions = null;
                this.$refs.editor.pickSuggestion(suggestion, this.mentionState);
            },

            editorKeyDown(ev) {
                if(ev.key == "Tab") {
                    this.$refs.submitbutton.focus();
                    ev.preventDefault();
                }
            },
            /*
            editorKeyDown(key) {
                return;
                
                this.suggestions = null;
                if(key == "@"){
                    if (this.suggestionsFeatureActive) this.mentionStarted = true;
                }
                if(key == "Backspace") {
                    if(this.mentionState.length > 1) {
                        this.mentionState = this.mentionState.slice(0, -1);
                        return;
                    }
                    else if(this.mentionState.length == 1){
                        this.mentionState = "";
                        this.mentionStarted = false;
                        return;
                    }
                }
                if(key == " "){
                    this.mentionState = "";
                    this.mentionStarted = false;
                    return;
                }
                if(this.mentionStarted) {
                    this.mentionState += key;                
                    if(this.mentionState.length > 2) {
                        const oldValue = this.mentionState.substring(0);                        
                        setTimeout(() => {                            
                            if(oldValue == this.mentionState.substring(0)){                                     
                                api.post('/search/mentionSuggestions', {
                                    name: oldValue
                                }).then((r) => {                                    
                                    this.suggestions = r.data;
                                });
                            }
                        },500);
                    }
                }
                
                
            },
            */
            nodeChanged() {
                /*                
                this.mentionState = "";
                this.suggestions = null;
                */
            },
            getValue() {
                if(this.useCkEditor) {
                    return this.editorContent;
                }

                return this.$refs.sceditorcontainer.getValue();
            },
            setValue(value) {
                //console.log(value);

                var sanitizedValue = htmlSanitizer.sanitize(value);

                if(this.useCkEditor) {
                    this.editorContent = sanitizedValue;
                }
                else {
                    this.$refs.sceditorcontainer.setValue(sanitizedValue);                    
                }
            }
        },

        mounted() {
            var code = this.content; //.replace('<code>', '<pre><code class="language-plaintext">')
                //.replace('</code>', '</code></pre>'); 
            //console.log(code);
            if (code === null) code = '';
            this.setValue(code);
        }
    }

</script>

